import { calcColorStatusGeneral, cellLineaRazonSocial, emptyCell, emptyCellObject } from "@/shared";
import { Agendamiento } from "@/shared/interfaces";
import { MRT_ColumnDef } from "material-react-table";
import { Chip } from "@mui/material";
import { useMemo } from "react";
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral";
import { infoActivacionVisita } from "../components/visitas-finalizadas/estadoActivacionVisita";

export function useTableColumnsOrdenServicioVisita() {
    const columns = useMemo<MRT_ColumnDef<Agendamiento>[]>(
        () => [
            {
                accessorKey: "cliente_razon_social",
                header: "Cliente",
                size: 300,
                Cell: ({ row }) =>
                    cellLineaRazonSocial(
                        row.original?.contrato_data,
                        row.original.prospecto_data?.razon_social!
                    ),
            },
            {
                accessorKey: "identificacion",
                header: "Identificación",
                Cell: ({ row }) =>
                    row.original?.prospecto_data?.identificacion || "N/A",
            },
            {
                accessorKey: "coordenadas",
                header: "Coordenada",
                Cell: ({ row }) => emptyCell(row.original?.coordenadas),
            },
            {
                accessorKey: "direccion",
                header: "Dirección",
                Cell:({row})=>{
                    return <ModalObservacionGeneral
                    texto={emptyCellObject(row.original,"direccion")}
                    titleModal="Dirección"
                    title=""
                    />
                }

            },
            {
                accessorKey: "estado_agendamiento",
                header: "Estado Agendamiento",
                Cell: ({ row }) => {
                    const { estado_agendamiento } = row.original;
                    const color = calcColorStatusGeneral(estado_agendamiento); // sx usa color CSS (no clave de paleta)
                    return (
                        <Chip
                            //variant="Chip Filled"
                            sx={{ color, borderColor: color }}
                            label={estado_agendamiento}
                        />
                    );
                },
            },
            {
                accessorKey: "resumen_activacion",
                header: "Activación",
                size: 140,
                Cell: ({ row }) => {
                    const info = infoActivacionVisita(row.original as any);
                    return (
                        <Chip
                            size="small"
                            variant={info.pendiente ? "filled" : "outlined"}
                            color={info.color}
                            label={info.label}
                        />
                    );
                },
            },
            /* {
                accessorKey: "estado_llamada",
                header: "Estado Llamada",
                Cell: ({ row }) => {
                    const { estado_llamada } = row.original;
                    return (
                        <Chip
                            variant="outlined"
                            color={estado_llamada == EstadosLlamadaEnumChoice.NO_CONTESTA ? "warning" : "success"}
                            label={estado_llamada}
                        />
                    );
                },
            }, */
            {
                accessorKey: "provincia_nombre",
                header: "Provincia",
                Cell: ({ row }) => emptyCellObject(row.original?.provincia_data, "nombre"),
            },
            {
                accessorKey: "ciudad_nombre",
                header: "Ciudad",
                Cell: ({ row }) => emptyCellObject(row.original?.ciudad_data, "nombre"),
            },
            {
                accessorKey: "sector_nombre",
                header: "Sector",
                Cell: ({ row }) => emptyCellObject(row.original?.sector_data, "nombre"),
            },
            {
                accessorKey: "zona_nombre",
                header: "Zona",
                Cell:({row})=>row.original?.zona_data_nombre || '-'
                //Cell: ({ row }) => emptyCellObject(row.original?.zona_data, "nombre"),
            },
            {
                accessorKey: "celular",
                header: "CELULAR CLIENTE",
                Cell: ({ row }) => row.original?.prospecto_data?.celular || "N/A",
            },
            {
                accessorKey: "celular_2",
                header: "CELULAR 2",
                Cell: ({ row }) => row.original?.preventa_data?.celular_2 || "N/A",
            },
        ],
        []
    );
    return {
        columns,
    };
}